<template>
  <div class="dashboard-container">
    <div class="body">
      <span class="detail">教师详情</span>
      <span class="el-icon-circle-close" style="font-size: 28px;" @click="goBack"></span>
    </div>
    <div class="app-container">
      <div class="filter-container">
        <div class="header">
          <!-- <div class="header">
          <el-button
            type="text"
            icon="el-icon-switch-button"
            >结课</el-button
          >
          <el-button
            type="text"
            icon="el-icon-close"
            >取消结课</el-button
          >
          <el-button
            type="text"
            icon="el-icon-edit-outline"
            >修改课节</el-button
          >
        </div> -->
          <div class="dd">
            <div class="realname">{{ teacherData.realname }}</div>
          </div>
          <el-form :inline="true">
            <el-row>
              <el-col class="bbb" style="width:90% !important">
                <!-- <el-form-item
                  style="float: left; margin-left: 10px"
                >
                  <span class="realname">{{ teacherData.realname }}</span>
                </el-form-item> -->
                <div class="body1">
                  <el-form-item label="联系电话:">
                    <span>{{ teacherData.telephone }}</span>
                  </el-form-item>
                  <el-form-item style="margin-left: 10px;" label="年龄">
                    <span>{{ teacherData.age }}</span>
                  </el-form-item>
                  <el-form-item style="margin-left: 10px;" label="身份证号:">
                    <span>{{ teacherData.cardId }}</span>
                  </el-form-item>
                  <el-form-item style="margin-left: 10px;" label="学科:">
                    <span>{{ teacherData.teach }}</span>
                  </el-form-item>
                  <el-form-item style="margin-left: 10px;" label="职级:">
                    <!-- {{  teacherData.jobtitle}} -->
                    <span v-if="teacherData.jobtitle === 1">初级讲师</span>
                    <span v-if="teacherData.jobtitle === 2">中级讲师</span>
                    <span v-if="teacherData.jobtitle === 3">高级讲师</span>
                    <span v-if="teacherData.jobtitle === 4">终级讲师</span>
                  </el-form-item>
                </div>
                <div class="body3">
                  <el-form-item label="在职状态:">
                    <span>{{ jobStatusText }}</span>
                  </el-form-item>

                  <el-form-item style="margin-left: 10px;" label="学历:">
                    <span>{{ teacherData.education }}</span>
                  </el-form-item>
                  <el-form-item style="margin-left: 10px;" label="毕业院校:">
                    <span>{{ teacherData.graduationSchool }}</span>
                  </el-form-item>
                  <el-form-item style="margin-left: 10px;" label="入职时间:">
                    <span>{{ teacherData.entryTime }}</span>
                  </el-form-item>
                </div>
                <div class="body2">
                  <el-form-item label="招聘渠道:">
                    <span>{{ teacherData.recruitmentChannel }}</span>
                  </el-form-item>
                  <el-form-item style="margin-left: 10px;" label="内推人:">
                    <span>{{ teacherData.introducerName }}</span>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div class="footer">
        <div class="card">
          <el-tabs v-model="activeName" type="card" @tab-click="handletabClick">
            <el-tab-pane style="float: left;margin-left: 10px;margin-bottom: 15px;" label="课时统计"
              name="first">课时统计</el-tab-pane>
            <el-tab-pane style="float: left;margin-left: 10px;margin-bottom: 15px;" label="跟进学员"
              name="second">跟进学员</el-tab-pane>
            <!-- <div class="btn" v-if="activeName === 'first'">
              <el-input
                size="small"
                style="width: 180px;"
                placeholder="学生查询"
              ></el-input>
              <el-date-picker
                size="small"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
              <el-button size="small" type="primary">查询</el-button>
            </div> -->
            <!-- 薪资汇总 -->
            <!-- <el-tab-pane
              style="float: left;margin-left: 10px;margin-bottom: 15px;"
              label="薪资汇总"
              name="second"
              >薪资汇总</el-tab-pane
            > -->
          </el-tabs>
          <el-divider class="line"></el-divider>
          <div class="course" v-if="activeName === 'first'">
            <el-table :data="courseList" border :header-cell-style="{
              background: '#fafafa'
            }">
              <el-table-column prop="date" sortable label="日期"> </el-table-column>
              <el-table-column prop="courseName" label="课程名称">
              </el-table-column>
              <el-table-column prop="courseNum" label="课次数" show-overflow-tooltip>
              </el-table-column>
              <!-- <el-table-column type="expand" label="学生姓名">
                <template slot-scope="props">
                  <el-table
                    :data="props.row.studentNames"
                    label-position="center"
                    inline
                    class="demo-table-expand"
                  >
                    <el-table-column prop="studentNames" label="学生姓名">
                    </el-table-column>
                    <el-table-column prop="courseNum" label="课节数">
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column> -->
              <el-table-column prop="startTime" label="开始时间">
              </el-table-column>
              <el-table-column prop="endTime" label="结束时间">
              </el-table-column>
              <el-table-column prop="courseStatus" label="结课状态">
              </el-table-column>
              <el-table-column prop="studentNames" label="学生姓名">
                <template slot-scope="scope">
                  <span v-for="(item, index) in scope.row.studentNames" :key="index">
                    {{ item }}
                    {{ index == scope.row.studentNames.length - 1 ? "" : "/" }}
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="course" v-if="activeName === 'second'">
            <el-form class="demo-form-inline" label-width="110px">
              <el-form-item label="学生名称:">
                <el-input v-model="fromState.studentName" placeholder="请输入学生名称" style="width:200px"></el-input>
              </el-form-item>

              <el-form-item label="地址:">
                <el-input v-model="fromState.address" placeholder="请输入地址" style="width:200px"></el-input>
              </el-form-item>

             <el-form-item label="上课时间:">
                <el-date-picker @change="timeValue1change" :disabled="isDisabled1"  v-model="timeValue1"   type="daterange" value-format="yyyy-MM-dd"  range-separator="至"  start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
              </el-form-item>

              <el-form-item label="时间:">
                <el-date-picker @change="timeValue2change" :disabled="isDisabled2"  v-model="timeValue2"    type="daterange" value-format="yyyy-MM-dd"  range-separator="至"  start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
              </el-form-item>

              <el-form-item label="老师状态:">
                <el-select  placeholder="请选择老师状态"  v-model="timeValue3" style="width: 100%"  clearable  filterable>
                    <el-option   v-for="item in valueList3" :key="item.id"  :value="item.id" :label="item.name" >  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="学员状态:">
                <el-select  placeholder="请选择学员状态"  v-model="timeValue4" style="width: 100%"  clearable  filterable>
                    <el-option   v-for="item in valueList4" :key="item.id"  :value="item.id" :label="item.name" >  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item width="200px">
                <div style="text-align: end;">
                  <el-button type="primary" @click="handleSearch">搜索</el-button>
                  <el-button @click="handleClearList">清除</el-button>
                </div>
              </el-form-item>
            </el-form>

            <el-table :data="followupList" border>
              <el-table-column prop="realname" label="姓名">
              </el-table-column>
              <el-table-column prop="sex" label="性别">
                <template slot-scope="scope">
                  {{ scope.row.sex == 2 ? "女" : "男" }}
                </template>
              </el-table-column>
              <el-table-column prop="wechat" label="微信"> </el-table-column>
              <el-table-column prop="address" label="地址"> </el-table-column>



              <el-table-column prop="lossStatus" label="老师状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.lossStatus === 0 || scope.row.lossStatus === '0'">未流失</span>
                  <span v-if="scope.row.lossStatus === 1 || scope.row.lossStatus === '1'">流失</span>
                </template>
              </el-table-column>
              <el-table-column prop="state" label="学员状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.state === 1 || scope.row.state === '1'">在读</span>
                  <span v-if="scope.row.state === 2 || scope.row.state === '2'">结业</span>
                  <span v-if="scope.row.state === 3 || scope.row.state === '3'">停课</span>
                  <span v-if="scope.row.state === 4 || scope.row.state === '4'">流失</span>
                </template>
              </el-table-column>
              <el-table-column prop="classFirstDate" label="首次课时间"> </el-table-column>
              <el-table-column prop="lossDate" label="时间"> </el-table-column>




              <!-- <el-table-column prop="grade" label="操作"> </el-table-column> -->
            </el-table>

            <el-pagination
                style="display: flex;justify-content: center;margin-top: 10px;"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="pageNo"
                :page-size="pageSize"
                :total="total"
                layout="total,prev, pager, next,sizes,jumper">
            </el-pagination>



          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../../config/api";
export default {
  props: ["id"],
  data () {
    return {
      isDisabled1:false,
      isDisabled2: false,
      teacherData: {
        realname: "",
        age: "",
        teach: "",
        telephone: "",
        jobStatus: 1,
        graduationSchool: "",
        cardId: "",
        education: "",
        entryTime: "",
        jobtitle: "",
        recruitmentChannel: "",
        introducerName: ""
      },
      name: "",
      activeName: "first",
      courseList: [], //课时统计
      salaryList: [], //工资汇总
      fromState: {
        address: "",
        studentName: ""
      },
      followupList: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,

      timeValue1: [],
      timeValue2: [],
      timeValue3: "",
      valueList3:[{id:2,name:'未流失'},{id:1,name:'流失'},{id:0,name:'未知'},{id:3,name:'结业'}],
      timeValue4: "",
      valueList4:[{id:1,name:'在读'},{id:2,name:'结业'},{id:3,name:'停课'},{id:4,name:'流失'}],
    };
  },
  created () {
    this.allTeachers();
  },
  computed: {
    jobStatusText () {
      return this.teacherData.jobStatus === 1 ? "在职" : "离职";
    }
  },
  mounted () {
    this.getCourse()
    // this.getfollowup()
  },
  methods: {
    handletabClick(
      {index}
    ){
      if(index === 0 || index === '0'){
        this.getCourse()
      }

      if(index === 1 || index === '1'){
        this.getfollowup()
      }

    },
    timeValue1change (e) {
      if(e && e.length > 0){
         this.isDisabled2 = true
      }else{
        this.isDisabled2 = false
      }
    },
    timeValue2change (e) {
      if(e && e.length > 0){
         this.isDisabled1 = true
      }else{
        this.isDisabled1 = false
      }
    },
    handleCurrentChange(val) {
      this.pageNo = val
      this.getfollowup()
    },

    handleSizeChange(val) {
      this.pageSize = val
      this.getfollowup()
    },

    goBack () {
      history.go(-1)
    },
    allTeachers () {
      axios
        .get(`${apiBaseUrl}/teacher/${this.id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          // console.log(res,'000000000000ujhujhghgfgdt')
          this.teacherData.realname = res.data.data.realname;
          this.teacherData.age = res.data.data.age;
          this.teacherData.teach = res.data.data.teach;
          this.teacherData.telephone = res.data.data.telephone;
          this.teacherData.jobStatus = res.data.data.jobStatus;
          this.teacherData.cardId = res.data.data.cardId;
          this.teacherData.education = res.data.data.education;
          this.teacherData.entryTime = res.data.data.entryTime;
          this.teacherData.recruitmentChannel =
            res.data.data.recruitmentChannel;
          this.teacherData.introducerName = res.data.data.introducerName;
          this.teacherData.graduationSchool = res.data.data.graduationSchool;
          this.teacherData.jobtitle = res.data.data.jobtitle;
        })
        .catch(err => {
          console.log(err);
        });
    },
    //查询课程统计列表
    getCourse () {
        axios .post(`${apiBaseUrl}/teacher/teacher_course_count/${this.id}`,{},{  headers:{  'authorization': sessionStorage.getItem('tokenInfo')  }  }) .then(res => {
          this.courseList = res.data.data;
          if(res.data.code === 200){
            this.$message.success('查询成功')
          }else{
            this.$message.error(res.data.message)
          }
        }).catch(err => {
          console.log(err);
          this.$message.error(err)
        });
    },
    // 跟进学员
    getfollowup () {
      let params = {
        teacherId: this.id,
        studentName: this.fromState.studentName,
        address: this.fromState.address,
        pageNo: this.pageNo,
        pageSize: this.pageSize,

        lossStatus: this.timeValue3,
        classStartDate: this.timeValue1.length > 0 ? this.timeValue1[0] : null,
        classEndDate: this.timeValue1.length > 0 ? this.timeValue1[1] : null,
        lossStartDate: this.timeValue2.length > 0 ? this.timeValue2[0] : null,
        lossEndDate: this.timeValue2.length > 0 ? this.timeValue2[1] : null,

        state: this.timeValue4,

      }
      axios
        .post(`${apiBaseUrl}/teacher/getStudentList`, params,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          let { pageNo, pageSize, total, records} = res.data.data.data;

          if(records.length > 0){
            this.followupList = records
          }else{
            this.followupList = []
          }
          this.pageNo = pageNo
          this.pageSize = pageSize
          this.total = total

          if(res.data.code === 200){
            this.$message.success('查询成功')
          }else{
            this.$message.error(res.data.message)
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(err)
        });
    },
    handleSearch () {
      this.getfollowup()
    },
    handleClearList () {
      this.timeValue1 = []
      this.timeValue2 = []
      this.timeValue3 = ""
      this.timeValue4 = ""
      this.isDisabled1 = false
      this.isDisabled2 = false
      this.fromState = {  studentName: "",   address: "",   }
      this.getfollowup()
    },
    handleClick () { }
  }
};
</script>

<style scoped>
.body {
  display: flex;
  background-color: #fff;
  height: 40px;
  line-height: 40px;
  align-items: center;
  justify-content: space-between;
}

.detail {
  float: left;
  margin-left: 10px;
}


.header {
  display: flex;
  background-color: #fafafa;
  border: 1px solid #e1e1e1;
  margin-top: 10px;
}

.footer {
  background-color: #fff;
  margin-top: 10px;
  height: 800px;
}

.stu {
  margin-left: 10px;
  margin-right: 10px;
}

.deep {
  background-color: #fff;
  margin-top: 10px;
  height: 300px;
}

.course {
  margin-left: 10px;
  margin-right: 10px;
  margin-top: -10px;
}

.sub {
  border: 1px solid #e1e1e1;
  height: 55px;
}

.realname {
  font-size: 20px;
  color: #fff;
  font-weight: 600;
  text-align: center;
}

.card {
  height: 40px;
}

.btn {
  margin-right: 500px;
  margin-bottom: 5px;
}

.dd {
  float: left;
  border-radius: 50px;
  width: 80px;
  height: 80px;
  line-height: 80px;
  background-color: #1c86ee;
  margin-left: 15px;
  margin-top: 5px;
  margin-right: 20px;
}

.bbb {
  width: 70%;
  height: 20px;
}

.body1 {
  display: flex;
  white-space: nowrap;
  /* width: 100%; */
  /* flex-wrap: nowrap; */
}

.body3 {
  margin-top: -40px;
  white-space: nowrap;
  /* margin-right: 475px; */
  display: flex;
  /* width: 100%; */
  /* flex-wrap: nowrap; */

}

.body2 {
  /* margin-right: 779px; */
  white-space: nowrap;
  margin-top: -40px;
  display: flex;
  /* width: 100%; */
  /* flex-wrap: nowrap; */
}

.line {
  margin-top: 5px;
}

/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .dashboard-container {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  /* #oo >>> .el-dialog {
    width: 70% !important;
  }
  .pop{
    margin-left: -15% !important;
  }
  #ff>>> .el-dialog {
    width: 70% !important;
  } */
}

.demo-form-inline {
  flex-wrap: wrap;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/manager/components/TeacherDetail.vue